import { Component, type ReactNode } from "react";
import { Sentry } from "@/lib/sentry";

interface State { hasError: boolean; error: Error | null; }

export default class ErrorBoundary extends Component<{ children: ReactNode; fallbackMessage?: string }, State> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: any) {
    console.error("ErrorBoundary caught:", error, info?.componentStack);
    Sentry.captureException(error, {
      contexts: { react: { componentStack: info?.componentStack } },
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="p-8 max-w-xl mx-auto mt-20">
          <h1 className="text-xl font-bold text-red-600 mb-2">Något gick fel</h1>
          <p className="text-sm text-gray-600 mb-4">{this.props.fallbackMessage ?? "Ett oväntat fel uppstod."}</p>
          <pre className="text-xs bg-gray-100 p-4 rounded-lg overflow-auto whitespace-pre-wrap max-h-60 mb-4">
            {this.state.error?.message}
            {"\n\n"}
            {this.state.error?.stack}
          </pre>
          <button
            className="px-4 py-2 bg-blue-600 text-white rounded-md text-sm"
            onClick={() => { this.setState({ hasError: false, error: null }); window.location.reload(); }}
          >
            Ladda om sidan
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
